import { connect } from 'react-redux';
import Home from './Home';

import { setToggleView } from '../common/settings/actions';
import { getAnnualResults } from '../Simulator/TabBar/Results/selectors';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    isLocked: state.isLockedUI.isLocked,
    authToken: state.auth.authToken,
    toggleView: state.settings.toggleView,
    firstName: state.contactUI.firstName,
    projectState: state.projectaddress.projectState,
    companyName: state.clientInfoUI.companyName,
    setToggleView,
});


const mapDispatchToProps = {
    setToggleView,
};


export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.js